import { TLocale } from '@internal/utils/machine/i18n/TLocale'
import {
  imageTransformationsToString,
  ProfilePictureMedia,
} from '@renderer-ui-library/molecules'
import dayjs from 'dayjs'
import { SetOptional } from 'type-fest'

export type TSalesManagerPayload = {
  id: string
  attributes: TSalesManager
}

export type TSalesManager = {
  id: string
  firstName: string
  lastName: string
  email: string
  slackUserId: string
  additionalMentionsSlackUserIds: string | null
  languagesSpoken: string
  isSalesManager: boolean
  isBusinessSpecialist: boolean
  acceptsMessages: boolean
  jobTitle: string
  bioTitle: string
  bioText: string
  enabled: boolean
  countries: TCountry[]
  zohoUserId: string
}

type TCountry = {
  id: string
  locale: TLocale
}

export const getProfilePictureUrl = (
  media: SetOptional<ProfilePictureMedia, 'name' | 'type'>
) => {
  const queryParams = new URLSearchParams({
    updatedAt: dayjs().format('YYYY-MM-DD'),
  })
  const transformations = imageTransformationsToString(
    media.transformations ?? {}
  )
  if (transformations) {
    queryParams.append('tr', transformations)
  }

  return `https://ik.imagekit.io/efarm/user-profile-picture/${media.zohoUserId}/${media.variant}?${queryParams.toString()}`
}

export const getName = (salesManager: TSalesManager) =>
  `${salesManager.firstName} ${salesManager.lastName}`.trim()
